import { h } from 'vue'
import { registrarFuncao } from '@/components/base/workflow/aprovacoes/aprovacoesRegistry'
import { formatarDataBR } from '@/utils/useDataBR'
import FiltrosPedidoVenda from './FiltrosPedidoVenda.vue'
import DetalhesPedidoVendaEnxuto from './DetalhesPedidoVendaEnxuto.vue'
import DetalhesPedidoVendaCompleto from './DetalhesPedidoVendaCompleto.vue'

const formatarValor = (valor) => {
  if (valor == null) return '-'
  try {
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor)
  } catch (e) {
    return valor?.toFixed(2) ?? '-'
  }
}

// Renderers para slots de coluna (componentes inline)
const slotRenderers = {
  resumoAprovacao: {
    props: ['row'],
    render () {
      return this.row.resumoSolicitacao || '-'
    }
  },
  acoes: {
    props: ['row', 'abrirModal'],
    render () {
      return h('div', { class: 'd-flex justify-content-end gap-1 acoes-wrapper' }, [
        h('button', {
          class: 'btn btn-sm btn-outline-info',
          onClick: () => this.abrirModal(this.row),
          title: 'Analisar'
        }, [
          h('i', { class: 'bi bi-search me-1' }),
          ' Analisar'
        ])
      ])
    }
  }
}

const definicao = {
  chave: 'PedidoVendaComercialReanalise',
  titulo: 'Aprovação Comercial e Reanálise - Pedidos de Venda',
  subtitulo: 'Análise e aprovação comercial e reanálise por financiamento de pedidos pendentes',
  apiEndpoint: '/WorkflowAprovacaoAnalise',
  entityKey: 'idWorkflowAprovacaoAnalise',
  campoHeader: 'resumoSolicitacao',
  endpointLista: '/pendentes?processo=WORK_APR_PROCESSO3,WORK_APR_PROCESSO5',
  endpointAprovar: '/aprovar',
  endpointReprovar: '/reprovar',
  listasTabelas: ['WorkflowAprovacaoAnalise', 'PedidoVenda', 'PedidoVendaProduto', 'PedidoVendaCondicaoPg'],
  nomeEntidade: 'solicitação de aprovação comercial/reanálise',
  nomeEntidadeTitle: 'Solicitação de Aprovação Comercial/Reanálise',

  formatarValor,

  colunas: [
    { field: 'idWorkflowAprovacaoAnalise', label: '#', width: 30, sortable: true, formatter: (v, row) => '#' + row.idWorkflowAprovacaoAnalise },
    { field: 'resumoSolicitacao', label: 'Resumo', width: 200, sortable: false, slotName: 'resumoAprovacao' },
    { field: 'nomeSolicitante', label: 'Solicitante', width: 100, sortable: false },
    { field: 'tsEnviadoAprovacao', label: 'Enviado', width: 80, align: 'center', sortable: true, formatter: (v, row) => formatarDataBR(row.tsEnviadoAprovacao) },
    { field: 'nomeGrupoAprovador', label: 'Grupo', width: 140, sortable: false },
    { field: 'nomeAprovador', label: 'Aprovador', width: 100, sortable: false },
    { field: 'acoes', label: 'Ações', width: 50, align: 'right', slotName: 'acoes', resizable: false, sortable: false }
  ],

  // Renderers para slots de coluna
  slotRenderers,

  // Componentes dos slots
  componenteFiltros: FiltrosPedidoVenda,
  componenteDetalhesEnxuto: DetalhesPedidoVendaEnxuto,
  componenteDetalhesCompleto: DetalhesPedidoVendaCompleto,

  // Mensagens do modal
  modalTitulo: 'Análise da Solicitação Comercial/Reanálise',
  modalTamanho: 'xl',
  modalCorHeader: 'var(--bs-info)',

  // Mensagens de confirmação
  confirmacaoReprovarTitulo: 'Reprovar Solicitação Comercial/Reanálise',
  confirmacaoReprovarMensagem: 'Tem certeza que deseja <strong>reprovar</strong> esta solicitação de aprovação comercial/reanálise?<br><br><textarea id="observacaoReprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',
  confirmacaoAprovarTitulo: 'Aprovar Solicitação Comercial/Reanálise',
  confirmacaoAprovarMensagem: 'Tem certeza que deseja <strong>aprovar</strong> esta solicitação de aprovação comercial/reanálise?<br><br><textarea id="observacaoAprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',

  // Textos do grid
  emptyMessage: 'Nenhuma solicitação de aprovação comercial ou reanálise pendente encontrada.',
  hintMessage: 'Duplo clique na linha para analisar a solicitação',

  // Filtros padrão
  filtrosPadrao: {
    buscaResumo: '',
    idGrupoAprovador: null
  }
}

registrarFuncao('PedidoVendaComercialReanalise', definicao)

export default definicao
